export default {
  state: true,
  filter: '',
  todos: [],
  storeId: 'app',
};
